import { useAppContext } from "../../context/AppContext";
import { ScheduleTrans } from "../../utils/translations";

/**
 * @param {string} [wrapClassName] – outer wrapper; use flex-1 when sitting next to TelegramSection
 */
export default function WhatsAppSection({ wrapClassName } = {}) {
    const { language, country } = useAppContext();
    const details = ScheduleTrans[language];

    if (language !== "russian" || country !== "IL") return null;

    const outerClass = wrapClassName ?? "w-fit mx-auto ";

    return (
        <div className={outerClass}>
            <div className="bg-green-50 border-2 border-green-200 rounded-2xl p-3 flex items-center justify-center max-w-md mx-auto">
                <div className="flex-1">
                    <p className="text-sm text-gray-700 mb-2">{details.joinStudioChat} 💬</p>
                    <a
                        href="https://chat.whatsapp.com/Kz84ggItwtU3JLTLXDBQrJ"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="inline-block bg-green-500 hover:bg-green-600 text-white font-semibold text-xs py-2 px-4 rounded-lg transition"
                    >
                        {details.whatsappGroup}
                    </a>
                </div>
            </div>
        </div>
    );
}